import PropTypes from 'prop-types';
import React, {Component} from 'react';

//components
import CloudinaryPicture from 'components/CloudinaryPicture';
import ChecklistOptionBinaryBagde from 'components/ChecklistOptionBinaryBadge';
import ChecklistOptionScoreBagde from 'components/ChecklistOptionScoreBadge';

import {INSTRUCTION_TYPE} from 'enums';

//styles
import {
  Content,
  StepContentDesktop,
  StepContentMobile,
  StepNumberDesktop,
  StepNumberMobile,
  StepOverviewCardLink,
  StepOverviewCardStatic,
  StatusIcons,
  CheckedStatus,
  UncheckedStatus,
  SkippedStatus,
  ReportIssueIcon,
  StepContentWrapper,
  AddDetailsIcon,
  StyledIconsWrapper,
  AddDetailsIconScoring,
  ReportIssueIconScoring,
  IconWrapper
} from './styles';

class StepOverviewCardBase extends Component {
  static defaultProps = {
    checkInfo: null,
    instructionType: INSTRUCTION_TYPE.INSTRUCTION,
    shouldShowSpinnerWhileLoading: false
  };

  static propTypes = {
    checkInfo: PropTypes.shape({
      checked: PropTypes.bool,
      feedbackText: PropTypes.string,
      mediaUrl: PropTypes.string,
      unchecked: PropTypes.bool
    }),
    instructionType: PropTypes.oneOf([INSTRUCTION_TYPE.INSTRUCTION, INSTRUCTION_TYPE.CHECKLIST]),
    shouldShowSpinnerWhileLoading: PropTypes.bool
  };

  render() {
    const {imageSizes, step, store, route, params, device, shouldShowSpinnerWhileLoading, instructionType, checkInfo} =
      this.props;
    const {
      platform: {
        hasChecklistsEnabled,
        developmentFeatureFlags: {checklistScoring}
      },
      instructionPage
    } = store;
    const {instructionHtml, number} = step;
    const isLink = store && store.router && route;
    const StepOverviewCard = isLink ? StepOverviewCardLink : StepOverviewCardStatic;
    const StepContent = device === 'mobile' ? StepContentMobile : StepContentDesktop;
    const StepNumber = device === 'mobile' ? StepNumberMobile : StepNumberDesktop;
    const mediaUrl = step.imageUrl;
    const metadata = step.metadata ? step.metadata : step.media && step.media.metadata ? step.media.metadata : {};
    const hasFeedback = checklistScoring && checkInfo && (checkInfo.feedbackText || checkInfo.mediaUrl);
    const hasChecklistEscalation = checklistScoring && checkInfo && checkInfo.escalationAttemptsIds;

    const isChecklist = instructionType === INSTRUCTION_TYPE.CHECKLIST;

    let statusIcons;
    if (!checklistScoring) {
      if (checkInfo) {
        const {checked, unchecked, feedbackText, mediaUrl, escalationAttemptsIds} = checkInfo;

        statusIcons = (
          <StatusIcons>
            {checked && <CheckedStatus />}
            {unchecked && <UncheckedStatus />}
            {!checked && !unchecked && <SkippedStatus />}
            {(feedbackText || mediaUrl) && <AddDetailsIcon />}
            {escalationAttemptsIds && <ReportIssueIcon />}
          </StatusIcons>
        );
      } else {
        statusIcons = (
          <StatusIcons>
            <SkippedStatus />
          </StatusIcons>
        );
      }
    } else {
      let selectedOption = null;
      if (checkInfo) {
        const {optionId} = checkInfo;
        const checklistOptions = instructionPage?.currentInstruction?.checklistTemplate?.options;
        selectedOption = checklistOptions.find(option => option.id === optionId);
      }
      const checklistType = instructionPage?.currentInstruction?.checklistTemplate?.type;

      statusIcons = (
        <StatusIcons>
          {!selectedOption && <ChecklistOptionScoreBagde />}
          {selectedOption && checklistType === 'BINARY' && (
            <ChecklistOptionBinaryBagde value={!!selectedOption.value} />
          )}
          {selectedOption && checklistType === 'SCORE' && <ChecklistOptionScoreBagde label={selectedOption.option} />}
        </StatusIcons>
      );
    }

    return (
      <StepOverviewCard store={store} route={route} params={params} data-cy="step-overview-card">
        <Content isLink={isLink} device={device}>
          <StyledIconsWrapper>
            {hasFeedback && (
              <IconWrapper>
                <AddDetailsIconScoring />
              </IconWrapper>
            )}
            {hasChecklistEscalation && (
              <IconWrapper>
                <ReportIssueIconScoring />
              </IconWrapper>
            )}
          </StyledIconsWrapper>
          <CloudinaryPicture
            aspectRatio={4 / 3}
            metadata={metadata}
            shouldShowSpinnerWhileLoading={shouldShowSpinnerWhileLoading}
            shouldShowOverlayShapes={true}
            src={mediaUrl}
            sizes={imageSizes}
          />
          <StepContentWrapper>
            <StepContent
              dangerouslySetInnerHTML={{__html: instructionHtml}}
              isCompact={true}
              isResponsive={false}
              isScrollable={false}
            />
            {hasChecklistsEnabled && isChecklist && statusIcons}
          </StepContentWrapper>
        </Content>
        <StepNumber number={number} />
      </StepOverviewCard>
    );
  }
}

export const StepOverviewCardDesktop = props => <StepOverviewCardBase device="desktop" {...props} />;

export const StepOverviewCardMobile = props => <StepOverviewCardBase device="mobile" {...props} />;
